import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import { title } from "../config/Config";

// img imports
import Light_img from "../Assets/Images/light_img.jpg";

const handleShare = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: "{title} Product",
        text: "Check out this amazing product!",
        url: window.location.href,
      });
    } catch (err) {
      console.log("Share cancelled");
    }
  } else {
    alert("Sharing not supported on this browser");
  }
};

const Result_main = () => {

  const [qty, setQty] = useState(1);

  const increaseQty = () => {
    setQty(qty + 1);
  };

  const decreaseQty = () => {
    if (qty > 1) {
      setQty(qty - 1);
    }
  };
const features = [
  {
    icon: "bi-shield-check",
    text: "100% Herbal And Natural",
  },
  {
    icon: "bi-star-fill",
    text: "Trusted By Thousands",
  },
  {
    icon: "bi-bag-fill",
    text: "Doctor Formulated",
  },
  {
    icon: "bi-truck",
    text: "Fast Delivery Nation Wide",
  },
];
const navigate = useNavigate();


  return (
    <>
       <div className="Product_sec">
      <Container>
        <Row className="pro_row">

          {/* Image */}
          <Col lg={5} md={6} xs={12}>
            <div className="product_imgs">
              <img src={Light_img} alt="img" />
            </div>
          </Col>

          {/* Content */}
          <Col lg={5} md={6} xs={12}>
            <div className="product_wrapper">

              <h6 className="brand">{title}</h6>

              <h2 className="title">
                Light N Care Anti Blemish Cream – Ayurvedic Formula with Green Tea & Aloe Vera Extract (50g)
              </h2>

              <div className="price_row">
                <span className="old_price">Rs. 1,200.00</span>
                <span className="new_price">Rs. 899.00</span>
                <span className="sale_badge">Sale</span>
              </div>

              <p className="shipping">
                <a href="#">Shipping</a> calculated at checkout.
              </p>

              {/* Quantity */}
              <div className="quantity_box">
                <i className="bi bi-dash" onClick={decreaseQty}></i>
                <span className="qty">{qty}</span>
                <i className="bi bi-plus" onClick={increaseQty}></i>
              </div>

              {/* Buttons */}
              <button className="add_cart" onClick={() => navigate("/card")}>Add to cart</button>
              <button className="btn-main buy_now"  onClick={() => navigate("/checkout-details")}>Buy it now</button>

              {/* Bottom */}
              <div className="bottom_row">

                <div className="share" onClick={handleShare}>
                  <i className="bi bi-share"></i>
                  <span>Share</span>
                </div>

                <div className="view_details" onClick={() => navigate("/productview")}>
                  <span>View full details</span>
                  <i className="bi bi-arrow-right"></i>
                </div>

              </div>

            </div>
          </Col>
        </Row>
      </Container>
    </div>


    <div className="feature_sec">
          <Container>
            <Row className="feature_row">

              <div className="feature_h">
                <h5>The Natural Ayurvedic Promise</h5>
              </div>

              {features.map((item, i) => (
                <Col lg={3} md={6} xs={12} key={i}>
                  <div className="feature_card">
                    <div className="icon_box">
                      <i className={`bi ${item.icon}`}></i>
                    </div>
                    <h4>{item.text}</h4>
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </div>

    </>
  );
};

export default Result_main;